import { forwardRef } from "react";

import type { ViewProps as ViewPropsRN, View as ViewRN } from "react-native";
import type { CircleProps as BaseCircleProps } from "tamagui";
import { Circle as BaseCircle } from "tamagui";

type NormalizedCircleProps = Omit<BaseCircleProps, "accessibilityLabel"> &
  Pick<ViewPropsRN, "onLayout">;

interface CircleProps extends BaseContainerViewProps, NormalizedCircleProps {}

// eslint-disable-next-line react/display-name
const Circle = forwardRef<ViewRN, CircleProps>(
  // eslint-disable-next-line max-params
  ({ accessibilityLabel, onLayout, testID, ...rest }, forwardedRef) => {
    return (
      <BaseCircle
        aria-label={accessibilityLabel}
        onLayout={onLayout}
        ref={forwardedRef}
        testID={testID}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    );
  },
);

export default Circle;
